module.exports = __webpack_public_path__ + "img/noteW.a107499f.png";